import type { CompanyPluginRepository } from "../../../domain/repositories/company/company-plugin-repository";
import { companyPluginApiService } from "../../api/company/company-plugin-api-service";
import type {
  CompanyPlugin,
  CompanyPluginConfigMap,
  CompanyPluginType,
} from "../../../domain/types/company-plugin";

export class CompanyPluginRepositoryImpl implements CompanyPluginRepository {
  async getPlugins(companyId: number): Promise<CompanyPlugin[]> {
    const response = await companyPluginApiService.getPlugins(companyId);
    return response.data ?? [];
  }

  async savePlugin<T extends CompanyPluginType>(
    companyId: number,
    pluginType: T,
    config: CompanyPluginConfigMap[T],
  ): Promise<CompanyPlugin> {
    const response = await companyPluginApiService.savePlugin(
      companyId,
      pluginType,
      config,
    );

    if (!response.data) {
      throw new Error(response.errorMsg || "연동 서비스 저장에 실패했습니다.");
    }

    return response.data;
  }

  async deletePlugin(
    companyId: number,
    pluginType: CompanyPluginType,
  ): Promise<void> {
    await companyPluginApiService.deletePlugin(companyId, pluginType);
  }
}
